import './App.css';
import PageManager from "./components/PageManager";
import Preloader from "./components/Preloader";
import AppErrorMessage from "./components/AppErrorMessage";
import AppLoginPopup from "./components/AppLoginPopup";
import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import en from './languages/en'
import nl from './languages/nl'
import {changeField} from "./redux/actions";
import axios from "axios";

function App() {

    const dispatch = useDispatch()

    const language = useSelector(state => state.language)

    useEffect(() => {
        const userLang = navigator.language || navigator.userLanguage;

        if (userLang === 'nl_NL' || userLang === 'nl') {

            dispatch(changeField({
                field: 'language',
                value: 'nl'
            }))

        } else {
            dispatch(changeField({
                field: 'language',
                value: 'en'
            }))
        }

    }, [])

    useEffect(() => {
        if (language === 'en') {
            dispatch(changeField({
                field: 'lang',
                value: en
            }))
        }

        if (language === 'nl') {
            dispatch(changeField({
                field: 'lang',
                value: nl
            }))
        }

    }, [language])

    useEffect(() => {
        axios({
            type: 'get',
            url: '/model/dl2/group1-shard1of3.bin'
        }).then((res) => {

        })
        axios({
            type: 'get',
            url: '/model/dl2/group1-shard2of3.bin'
        }).then((res) => {

        })
        axios({
            type: 'get',
            url: '/model/dl2/group1-shard3of3.bin'
        }).then((res) => {

        })
    }, [])

    return (
        <>
            <AppErrorMessage/>
            <AppLoginPopup />
            <Preloader/>
            <PageManager/>
        </>
    )
}

export default App
